import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import 'bulma/css/bulma.min.css';

export default function Signup() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nombres: "",
    apellidos: "",
    edad: "",
    cedulaRuc: "",
    ciudad: "",
    parroquia: "",
    usuario: "",
    email: "",
    password: "",
    repetirPassword: "",
    encargo: "",
  });

  const [error, setError] = useState("");
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    // Cargar usuarios si el token existe; si no, omitir para no fallar por auth
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(`${import.meta.env.VITE_API_URL || 'https://conexapi.fundacionnigma.org'}/api/users`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.ok ? res.json() : [])
      .then(data => setUsuarios(Array.isArray(data) ? data : []))
      .catch(() => setUsuarios([]));
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (
      !form.nombres ||
      !form.apellidos ||
      !form.edad ||
      !form.cedulaRuc ||
      !form.usuario ||
      !form.password ||
      !form.repetirPassword ||
      !form.encargo
    ) {
      setError("Por favor llena todos los campos obligatorios.");
      return;
    }

    if (form.password !== form.repetirPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    if (form.edad <= 0) {
      setError("Edad debe ser un número positivo.");
      return;
    }

    // Validar usuario o correo duplicado
    const usuarioExiste = usuarios.some(
      u =>
        u.usuario.toLowerCase() === form.usuario.toLowerCase() ||
        (u.email && form.email && u.email.toLowerCase() === form.email.toLowerCase())
    );
    if (usuarioExiste) {
      setError("El usuario o correo ya existe.");
      return;
    }

    // Mapear encargo a rol (usar "administrador" en lugar de "admin")
    const rolMap = {
      administrador: "administrador",
      cliente: "cliente",
      trabajadores: "trabajadores",
    };

    const nuevoUsuario = {
      nombres: form.nombres,
      apellidos: form.apellidos,
      edad: parseInt(form.edad),
      cedulaRuc: form.cedulaRuc,
      ciudad: form.ciudad || null,
      parroquia: form.parroquia || null,
      usuario: form.usuario,
      email: form.email || null,
      password: form.password,
      encargo: form.encargo,
      rol: rolMap[form.encargo] || form.encargo,
    };
    try {
      const resp = await fetch(`${import.meta.env.VITE_API_URL || 'https://conexapi.fundacionnigma.org'}/api/auth/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nuevoUsuario),
      });

      const data = await resp.json();
      if (!resp.ok) {
        setError(data?.error || 'No se pudo registrar');
        return;
      }

      alert('Usuario creado con éxito. Ya puedes iniciar sesión.');
      navigate('/login');
    } catch (err) {
      setError('Error de conexión');
    }
  };

  return (
    <div className="columns is-gapless is-fullheight" style={{ margin: 0 }}>
      <div className="column is-2" style={{ backgroundColor: '#2D2749' }}>
        <aside className="menu p-4">
          <div className="mb-6">
            <figure className="image is-128x128 mb-6">
              <img src="/logoN.png" alt="Logo Nigma" />
            </figure>
          </div>
          <ul className="menu-list">
            <li>
              <Link to="/dashboard" className="has-background-warning has-text-black">
                Home
              </Link>
            </li>
            <li>
              <Link to="/dashboard/ingresos" className="has-text-white">
                Ingresos
              </Link>
            </li>
            <li>
              <Link to="/dashboard/egresos" className="has-text-white">
                Egresos
              </Link>
            </li>
            <li>
              <Link to="/dashboard/contabilidad" className="has-text-white">
                Contabilidad
              </Link>
            </li>
            <li>
              <Link to="/dashboard/cierrecaja" className="has-text-white">
                Cierre de Caja
              </Link>
            </li>
            <li>
              <Link to="/dashboard/reportes" className="has-text-white">
                Reportes
              </Link>
            </li>
            <li>
              <Link to="/login" className="has-text-white">
                Cerrar sesión
              </Link>
            </li>
          </ul>
        </aside>
      </div>

      <div className="column is-10 has-background-light">
        <div className="section">
          <h1 className="title is-3">Registro - Creación de cuentas</h1>
          
          {error && (
            <div className="notification is-danger">
              <button className="delete" onClick={() => setError("")}></button>
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="mt-5">
            <div className="columns">
              <div className="column is-half">
                <div className="field">
                  <label className="label">
                    <span className="has-text-danger">*</span> Nombres:
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="nombres"
                      placeholder="Escribe dos nombres completos"
                      value={form.nombres}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="label">
                    <span className="has-text-danger">*</span> Edad:
                  </label>
                  <div className="control">
                    <div className="select is-fullwidth">
                      <select
                        name="edad"
                        value={form.edad}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Selecciona tu edad</option>
                        {[...Array(100)].map((_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="field">
                  <label className="label">Ciudad: <span className="is-size-7 has-text-grey">(opcional)</span></label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="ciudad"
                      placeholder="Escribe tu ciudad aquí"
                      value={form.ciudad}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="label">
                    <span className="has-text-danger">*</span> Usuario:
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="usuario"
                      placeholder="Escribe el usuario"
                      value={form.usuario}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="label">
                    <span className="has-text-danger">*</span> Contraseña:
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      type="password"
                      name="password"
                      placeholder="Escribe la contraseña"
                      value={form.password}
                      onChange={handleChange}
                      required
                      minLength={6}
                    />
                  </div>
                </div>
              </div>

              <div className="column is-half">
                <div className="field">
                  <label className="label">
                    <span className="has-text-danger">*</span> Apellidos:
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="apellidos"
                      placeholder="Escribe dos apellidos"
                      value={form.apellidos}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="label">
                    <span className="has-text-danger">*</span> Cédula/RUC:
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="cedulaRuc"
                      placeholder="Escribe tu cédula o RUC"
                      value={form.cedulaRuc}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="label">Parroquia: <span className="is-size-7 has-text-grey">(opcional)</span></label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="parroquia"
                      placeholder="Escribe tu parroquia"
                      value={form.parroquia}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="label">
                    Correo electrónico: <span className="is-size-7 has-text-grey">(opcional)</span>
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      type="email"
                      name="email"
                      placeholder="Escribe el correo electrónico del emprendimiento"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="label">
                    <span className="has-text-danger">*</span> Repetir contraseña:
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      type="password"
                      name="repetirPassword"
                      placeholder="Escribe nuevamente la contraseña"
                      value={form.repetirPassword}
                      onChange={handleChange}
                      required
                      minLength={6}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="columns">
              <div className="column is-half-desktop is-offset-one-quarter-desktop">
                <div className="field">
                  <label className="label">Encargo:</label>
                  <div className="control">
                    <div className="select is-fullwidth">
                      <select
                        name="encargo"
                        value={form.encargo}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Elige tu cargo</option>
                        <option value="administrador">Administrador</option>
                        <option value="cliente">Cliente</option>
                        <option value="trabajadores">Trabajadores</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="field mt-5">
                  <div className="control has-text-centered">
                    <button
                      type="submit"
                      className="button is-link is-medium px-6"
                      style={{ backgroundColor: '#2D8BFF' }}
                    >
                      Crear Cuenta
                    </button>
                  </div>
                </div>

                <p className="has-text-centered mt-4 is-size-7">
                  Esta página solo tiene acceso el admin
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
